import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import IconButton from '@mui/material/IconButton';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import EditIcon from '@mui/icons-material/Edit';
import LoadingInside from '../loading_inside';
import { Avatar } from '@mui/material';
import mosaicGuardians from '../../image/mosaicGuardians.png';
import CircularProgress from '@mui/material/CircularProgress';
import StopIcon from '@mui/icons-material/Stop';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';


export default function OpenIconSpeedDial( { play, fetch_image, fetchSpeech, fetchDelete, role, currentUser, message }) {
  // console.log('status', fetchSpeech)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (!play) {
      setOpen(false);
    }
  };

  React.useEffect(() => {
    if (!play) {
      setOpen(false);
    }
  }, [play]);


  const actions = [
    { disabled: true, icon: play?<StopIcon />:<PlayArrowIcon />, name: 'Play', handle: () => {fetchSpeech(message?.content[0]?.text?.value, message.id) }},
    { disabled: false, icon: <DeleteIcon />, name: 'Delete', handle: () => {fetchDelete(message.thread_id, message.id)}, color: 'rgb(203 84 84)' },
    { disabled: true, icon: <AddPhotoAlternateIcon />, name: 'Gen Image', handle: () => {fetch_image(message.content[0]?.text?.value)}, color: 'rgb(203 84 84)' },
    // { icon: <PrintIcon />, name: 'Print' },
    // { icon: <ShareIcon />, name: 'Share' },
  ];
  // if(message.metadata){
  //   console.log('message', message)
  // }
  return (
    <Box sx={{ transform: 'translateZ(0px)', flexGrow: 1 }}>
      
      <div className='spinner_inside_start' style={{ opacity: message?.status === 'in_progress' || play?1:0, height: '72px', width: '72px', top: '-8px', left: '0px' }}>
        <div className='shadow_inside'/>
      </div>
        {/* {(message?.status === 'in_progress' || play) && <CircularProgress size={68} sx={{  position: 'absolute', left: '2px', top: '-6px', zIndex: 1 }} />} */}
      
      <SpeedDial
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction='right'
        ariaLabel="SpeedDial openIcon example"
        sx={{   marginLeft: 1, mt: 1, position: 'absolute', top: 0}}
        // sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<Avatar 
          sizes='large'
          alt={currentUser?.nick_name}
          src={ role === 'assistant'?mosaicGuardians:"/static/images/avatar/7.jpg"}
          sx={{ width: 60, height: 60}}
          openIcon={<LoadingInside />} />}
      >
        {actions.map((action) => {
          if(!action.disabled){
            return (
            <SpeedDialAction
              key={action.name}
              icon={<IconButton disabled={action.disabled} sx={{ color: action.color || null}} onClick={action.handle}>
                      {action.icon}
                    </IconButton>}
              tooltipTitle={action.name}
              sx={{ color: action.color || null}}
              // onClick={action.handle}

            >
              
            </SpeedDialAction>
            )}
            else{
              return null;
            }
        })}
      </SpeedDial>
    </Box>
  );
}
